// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  TableRow,
  TableCell,
  Table,
  Divider,
  Checkbox,
  ListItemText,
  ListItem,
  Chip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

import { DndContext, PointerSensor, useSensor, useSensors, closestCenter } from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  horizontalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function LeadPipelineViewPage() {
  const pageTitle = "Lead Pipeline";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [leadPipeline, setLeadPipeline] = useState({});
  const [leadPipelineBuckets, setLeadPipelineBuckets] = useState([]);
  const [leadBuckets, setLeadBuckets] = useState([]);

  const [sortedPipelineBuckets, setSortedPipelineBuckets] = useState([]);

  useEffect(() => {
    setSortedPipelineBuckets(leadPipelineBuckets);
  }, [leadPipelineBuckets]);

  const sensors = useSensors(useSensor(PointerSensor));

  function SortableChip({ pb, onDelete }) {
    const id = pb.bucket.reference;

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    return (
      <MDBox
        ref={setNodeRef}
        display="flex"
        alignItems="center"
        style={{
          transform: CSS.Transform.toString(transform),
          transition,
        }}
      >
        <Icon
          {...attributes}
          {...listeners}
          sx={{
            cursor: "grab",
            fontSize: "16px",
            mr: 1,
            mb: 1,
          }}
        >
          drag_indicator
        </Icon>
        <Chip label={pb.bucket.title} onDelete={onDelete} color="info" sx={{ mr: 1, mb: 1 }} />
      </MDBox>
    );
  }

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    const oldIndex = sortedPipelineBuckets.findIndex((b) => b.bucket.reference === active.id);

    const newIndex = sortedPipelineBuckets.findIndex((b) => b.bucket.reference === over.id);

    if (oldIndex !== -1 && newIndex !== -1 && oldIndex !== newIndex) {
      const newItems = arrayMove(sortedPipelineBuckets, oldIndex, newIndex);

      // update positions
      const updated = newItems.map((item, index) => ({
        ...item,
        position: index + 1,
      }));

      setSortedPipelineBuckets(updated);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/leads/pipelines/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setLeadPipeline(result.data.data.pipeline);
            setLeadBuckets(result.data.data.buckets);
            setLeadPipelineBuckets(result.data.data.pipeline_buckets);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function deleteLeadPipeline() {
    setShowLoading(true);

    await axios
      .get(`portal/leads/pipelines/${ref}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updatePipeline() {
    if (sortedPipelineBuckets.length <= 0) {
      setSeverity("error");
      setErrMsg("Buckets have not been added to the pipeline.");
      setOpen(true);
      return;
    }

    console.log(sortedPipelineBuckets);

    setShowLoading(true);
    const json = {
      reference: ref,
      buckets: sortedPipelineBuckets
    };

    await axios
      .post("portal/leads/pipelines/update.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox mt={0} mb={1} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/leads/pipelines`);
              }}
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox>
            <MDBox sx={{ height: "100%", marginTop: "0px" }}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDBox>
                      <MDTypography variant="caption" fontWeight="light" fontSize={13}>
                        Lead PipeLine ({leadPipeline.type.title})
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="medium">
                        {leadPipeline.title}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Tooltip title="Delete Pipeline">
                        <MDButton
                          variant="contained"
                          color="error"
                          iconOnly
                          onClick={() => {
                            if (window.confirm("Delete Pipeline?") === true) {
                              deleteLeadPipeline();
                            }
                          }}
                        >
                          <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                            delete
                          </Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={3} display="flex">
                  <Card sx={{ width: "100%" }}>
                    <MDBox p={1}>
                      <MDBox p={1}>
                        <MDTypography variant="h6">Available Buckets</MDTypography>
                      </MDBox>

                      {leadBuckets
                        .filter(
                          (b) =>
                            !leadPipelineBuckets.find((pb) => pb.bucket.reference === b.reference)
                        )
                        .map((b) => (
                          <MDBox
                            key={b.reference}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                          >
                            <Chip label={b.title} />

                            <Icon
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                const newItem = {
                                  reference: b.reference,
                                  bucket: {
                                    reference: b.reference,
                                    title: b.title,
                                  },
                                  position: sortedPipelineBuckets.length + 1,
                                };

                                const updated = [...sortedPipelineBuckets, newItem];

                                // update BOTH states
                                setSortedPipelineBuckets(updated);
                                setLeadPipelineBuckets(updated);
                              }}
                            >
                              add
                            </Icon>
                          </MDBox>
                        ))}
                    </MDBox>
                  </Card>
                </Grid>

                {/* MIDDLE ARROW */}
                <Grid item xs={1} display="flex" alignItems="center" justifyContent="center">
                  <Icon fontSize="small">east</Icon>
                </Grid>

                {/* RIGHT: PIPELINE */}
                <Grid item xs={8} display="flex">
                  <Card sx={{ width: "100%", border: "2px dashed #ccc" }}>
                    <MDBox>
                      <MDBox p={1}>
                        <MDTypography variant="h6">Pipeline</MDTypography>
                        <MDTypography variant="body2" fontSize={13}>
                          Drag buckets to re-order pipeline
                        </MDTypography>
                      </MDBox>

                      <MDBox display="flex" alignItems="center" flexWrap="wrap" p={1}>
                        {/* {leadPipelineBuckets.map((pb, index) => {
                          const id = pb.bucket.reference;
                          const title = pb.bucket.title;

                          return (
                            <MDBox key={id} display="flex" alignItems="center">
                              <Chip
                                label={title}
                                onDelete={() => {
                                  setLeadPipelineBuckets((prev) =>
                                    prev.filter((x) => x.bucket.reference !== pb.bucket.reference)
                                  );
                                }}
                                color="success"
                                sx={{ mr: 1, mb: 1 }}
                              />

                              {index < leadPipelineBuckets.length - 1 && (
                                <Icon sx={{ mx: 1 }}>east</Icon>
                              )}
                            </MDBox>
                          );
                        })} */}
                        {sortedPipelineBuckets.length > 0 ? (
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                          >
                            <SortableContext
                              items={sortedPipelineBuckets.map((pb) => pb.bucket.reference)}
                              strategy={horizontalListSortingStrategy}
                            >
                              {sortedPipelineBuckets.map((pb, index) => {
                                const id = pb.bucket.reference;

                                return (
                                  <MDBox key={`${id}-${index}`} display="flex" alignItems="center">
                                    <SortableChip
                                      pb={pb}
                                      onDelete={() => {
                                        console.log(pb.bucket.reference);
                                        setSortedPipelineBuckets((prev) => {
                                          const updated = prev.filter(
                                            (x) => x.bucket.reference !== pb.bucket.reference
                                          );

                                          // keep base state in sync
                                          setLeadPipelineBuckets(updated);
                                          return updated;
                                        });
                                      }}
                                    />

                                    {index < sortedPipelineBuckets.length - 1 && (
                                      <Icon sx={{ mx: 1, mb: 1 }}>east</Icon>
                                    )}
                                  </MDBox>
                                );
                              })}
                            </SortableContext>
                          </DndContext>
                        ) : (
                          <MDTypography variant="body2">No buckets added yet.</MDTypography>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={3}>
              <Card>
                <MDBox p={1.5} align="right">
                  <MDButton
                    variant="contained"
                    color="dark"
                    startIcon={<Icon>save</Icon>}
                    onClick={() => {
                      updatePipeline();
                    }}
                  >
                    Save Changes
                  </MDButton>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LeadPipelineViewPage;
